import React from 'react';
import { useNavigate } from 'react-router-dom';
import type { NeedsFinalizationMatch } from '../../hooks/useHomeFeed';

interface FinalizationBannerProps {
  match: NeedsFinalizationMatch;
}

export default function FinalizationBanner({ match }: FinalizationBannerProps) {
  const navigate = useNavigate();

  return (
    <button
      type="button"
      onClick={() => navigate(`/match/${match.id}`)}
      style={{
        display: 'flex',
        alignItems: 'center',
        gap: 12,
        width: '100%',
        padding: '14px 16px',
        marginBottom: 16,
        backgroundColor: '#E53935',
        border: 'none',
        borderRadius: 14,
        cursor: 'pointer',
        textAlign: 'left',
        boxShadow: '0 4px 12px rgba(229, 57, 53, 0.25)',
      }}
    >
      <span style={{ fontSize: 22 }}>🚩</span>
      <div style={{ flex: 1, minWidth: 0 }}>
        <div style={{ color: '#FFF', fontSize: 15, fontWeight: 700 }}>
          ¡Finalizá el partido!
        </div>
        <div
          style={{
            color: 'rgba(255,255,255,0.85)',
            fontSize: 13,
            whiteSpace: 'nowrap',
            overflow: 'hidden',
            textOverflow: 'ellipsis',
          }}
        >
          {match.location} · Marcá el resultado final
        </div>
      </div>
      <span style={{ color: 'rgba(255,255,255,0.7)', fontSize: 18 }}>›</span>
    </button>
  );
}
